import { Button, Stack, Typography } from "@mui/material";
import StatusChip from "./StatusChip";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";


const AIANBlockButtons = (props: any) => {
    const navigate = useNavigate();
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducDataGen = ducDataObject?.GENERAL?.[ducDataObject?.GENERAL.length - 1]
    const ducData = ducDataObject?.AIAN?.[ducDataObject?.AIAN.length - 1]
    const secondDucExists = ducDataObject?.AIAN.length === 2

    const DucNotExpiringAndNotExpiredAIAN: boolean = !props.expiredAIAN && !props.expiringAIAN
    const DucExpiringNotExipiredAIAN: boolean = props.expiringAIAN && !props.expiredAIAN
    const DucInProgressNotSignedByOfficialAIAN: boolean = (ducData?.status === "InProgress" || ducData?.status === "Submitted") && !ducData?.dateSignedOfficial
    const notSubApplicantGen: boolean = !ducDataObject?.subApplicantGeneral && ducDataObject?.subApplicantGeneral !== undefined
    const notSubApplicant: boolean = !ducDataObject?.subApplicantAIAN && ducDataObject?.subApplicantAIAN !== undefined
    const DucInProgressAIAN: boolean = ducData?.status !== "NotSubmitted" && ducData?.status !== "Approved" && ducData?.status !== "Declined"
    const DucApprovedTrainingCompleteAIAN: boolean = ducData?.status === "Approved" && ducDataObject?.ducStatus === "TrainingComplete"
    const DucApprovedOrDeclinedAndTrainingCompleteAIAN: boolean = (ducData?.status === "Approved" || ducData?.status === "Declined") && ducDataObject?.ducStatus === "TrainingComplete"
    const DucNotDeclinedOrSecondDucDoesExistAIAN: boolean = (ducData?.status !== 'Declined' || secondDucExists)


    const setOldStatus = () => {
        localStorage.setItem('status', ducData?.status)
    }

    const handleClickAian = () => {
        setOldStatus()
        localStorage.setItem('edit', "false")
        localStorage.setItem('formType', "AIAN")
        if((ducData?.status === 'NotSubmitted' || ducData?.status === 'Declined') && ducDataObject?.group){
            props.setOpen(true)
        }
        else{
            navigate("/duc/request");
        }
    }

    const handleClickAianView = () => {
        setOldStatus()
        localStorage.setItem('edit', "false")
        localStorage.setItem('formType', "AIAN")
        navigate("/duc/request");
    }

    const handleClickEdit = () => {
        setOldStatus()
        if(ducData?.group){
            localStorage.setItem('isGroup', "true")
        }
        else{
            localStorage.setItem('isGroup', "false")
        }
        localStorage.setItem('formType', "AIAN")
        localStorage.setItem('AddSub', "false")
        localStorage.setItem('edit', "true")
        navigate("/duc/request");
    }

    const handleClickViewSub = () => {
        setOldStatus()
        navigate("/duc/sub-applicants",{ state: { "type": "AIAN" } })
    }

    const handelCLickAddSub = () => {
        setOldStatus()
        localStorage.setItem('formType', "AIAN")
        localStorage.setItem('AddSub', "true")
        localStorage.setItem('edit', "true")
        localStorage.setItem('isGroup', "true")
        navigate("/duc/request")
    }

    const handleClickDelete = () => {
        setOldStatus()
        props.setCancelRefresh(!props.cancelRefresh)
        props.setOpenDeleteModal(true);
    }

    return (
        <Stack
            flexDirection="row"
            justifyContent="space-between"
            gap={3}>
            <Stack
                flexDirection="row"
                gap={2}
                alignItems="center"
                maxWidth={"600px"}>
                <Typography fontSize="16px" fontWeight="600" variant="h2" id="aian-header">
                Data Use Certification for Research on NIH Brain Development Cohorts Data from American Indian/Alaska Native Individuals (A-DUC)
                </Typography>

                {ducData?.status  === 'Approved' && DucNotExpiringAndNotExpiredAIAN &&
                <StatusChip
                    state="approved"/>}

                {DucExpiringNotExipiredAIAN &&
                <StatusChip
                    state='expiring'
                    time={new Date(ducData.expiresOn).getMonth() - new Date().getMonth()}/>}

                {props.expiredAIAN &&
                <StatusChip
                    state='expired'/>}
            </Stack>

            

            {ducData?.status === 'NotSubmitted' &&
            <Stack
                flexDirection="row">
                {ducDataGen?.status !== 'Approved' &&
                    <Typography
                        fontSize="11px"
                        fontWeight="600"
                        marginRight="20px">
                        An approved general data use certification is required
                    </Typography>
                }
                {notSubApplicantGen &&
                    <Button
                        id="duc-aian-request-access-button"
                        variant="primary"
                        onClick={handleClickAian}
                        sx={{ alignSelf: "center", minWidth: "max-content" }}
                        disabled={ducDataGen?.status !== 'Approved'}
                    >
                        Request access
                    </Button>
                }
                {!notSubApplicantGen &&
                    <Stack>
                        <Typography fontSize="14px" fontWeight="600">
                            Sub-applicants must ask their PI or Lead Investigator to submit the request.
                        </Typography>
                    </Stack>
                }
            </Stack>}

            {ducData?.status === 'Declined' && !secondDucExists &&
            <Button
                id="duc-aian-new-request-button"
                variant="primary"
                onClick={handleClickAian}
                sx={{ alignSelf: "center" }}
            >
                New Request
            </Button>}

            {ducData?.status !== 'NotSubmitted' && DucNotDeclinedOrSecondDucDoesExistAIAN && DucNotExpiringAndNotExpiredAIAN && props.checkedCurrentStatus
            &&
            <Stack
                flexDirection="row"
                gap={4}
                alignItems={'center'}>
                <Button
                    id="duc-aian-view-request-button"
                    variant="primary"
                    onClick={handleClickAianView}
                    sx={{ minWidth: "max-content" }}
                >
                    {(ducData?.status !== "Approved") ? "View Request": "View Certification"}
                </Button>

                {DucInProgressNotSignedByOfficialAIAN && notSubApplicant &&
                    <Button
                        id="duc-aian-edit-request-button"
                        variant="secondary"
                        onClick={handleClickEdit}
                        sx={{ minWidth: "max-content" }}
                    >
                        Edit Request
                    </Button>}

                {DucInProgressAIAN && notSubApplicant &&
                    <Button
                        id="duc-aian-cancel-button"
                        variant="outlined"
                        color="error"
                        sx={{ minWidth: "max-content" }}
                        onClick={handleClickDelete}
                    >
                        Cancel
                    </Button>
                }
                {(DucApprovedTrainingCompleteAIAN || secondDucExists) && ducData.group && notSubApplicant &&
                    <Button
                        id="duc-aian-view-subapplicants-button"
                        variant="primary"
                        onClick={handleClickViewSub}
                        sx={{ minWidth: "max-content" }}
                    >
                        View Sub-applicant(s)
                    </Button>}

                {DucApprovedOrDeclinedAndTrainingCompleteAIAN && ducData.group && notSubApplicant &&
                    <Button
                        sx={{ minWidth: "max-content" }}
                        id="duc-aian-add-subapplicant-button"
                        variant="primary"
                        startIcon={<AddBoxOutlinedIcon/>}
                        onClick={handelCLickAddSub}>
                        Add new Sub-applicant
                    </Button>}

            </Stack>}

            {(props.expiringAIAN || props.expiredAIAN) &&
            <Button
                id="duc-aian-renewal-button"
                variant="primary"
                onClick={handleClickAian}
                sx={{ alignSelf: "center",
                    marginLeft: "75px",
                }}
            >
                Renewal
            </Button>}

        </Stack>
    )
}

export default AIANBlockButtons